/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminSeedTeamResponse
 */
export interface AdminSeedTeamResponse {
    /**
     * Tournament team response object
     * @type {object}
     * @memberof AdminSeedTeamResponse
     */
    team?: object;
    /**
     * 
     * @type {string}
     * @memberof AdminSeedTeamResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the AdminSeedTeamResponse interface.
 */
export function instanceOfAdminSeedTeamResponse(value: object): value is AdminSeedTeamResponse {
    return true;
}

export function AdminSeedTeamResponseFromJSON(json: any): AdminSeedTeamResponse {
    return AdminSeedTeamResponseFromJSONTyped(json, false);
}

export function AdminSeedTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminSeedTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': json['team'] == null ? undefined : json['team'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function AdminSeedTeamResponseToJSON(json: any): AdminSeedTeamResponse {
    return AdminSeedTeamResponseToJSONTyped(json, false);
}

export function AdminSeedTeamResponseToJSONTyped(value?: AdminSeedTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': value['team'],
        'message': value['message'],
    };
}

